// English translation dictionary — read via dot-path keys (e.g. "common.close"), see LanguageContext.jsx.
export default {
  common: {
    close: 'Close',
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    refresh: 'Refresh',
    loading: 'Loading…',
    understood: 'Got it, close',
    yes: 'Yes',
    no: 'No',
    test: 'Test',
    spot: 'Spot',
    futures: 'Futures',
    long: 'Long',
    short: 'Short',
    logout: 'Log out',
    settings: 'Settings',
    help: 'Help',
    apply: 'Apply',
    back: 'Back',
    error: 'Error',
    success: 'Success',
  },
  app: {
    twoFactor: '2FA',
    menu: 'Menu',
    wsConnected: 'Live',
    wsConnecting: 'Connecting…',
    wsError: 'Error',
    wsReconnecting: 'Reconnecting…',
    logs: 'Logs',
    backtest: 'Backtest',
    support: 'Support',
    help: 'Help',
    settings: 'Settings',
    logout: 'Log out',
    langButtonTitle: 'Change language',
    themeButtonTitle: 'Change theme',
    eventBotStarted: '🤖 Bot Started',
    eventBotStopped: '⏹ Bot Stopped',
    eventTradeOpened: '✅ Trade Opened',
    eventTradeClosedProfit: '💰 Trade Closed (Profit)',
    eventTradeClosedLoss: '📉 Trade Closed (Loss)',
    eventSlCooldown: '⏸ SL Protection Active',
    eventSlCooldownDetail: '{symbol} — no new trades for {min} min',
    eventSignalSkipped: '⏭ Signal Skipped',
    eventError: '❌ Error',
    errStartFailed: 'Failed to start',
    errStopFailed: 'Failed to stop',
    errCloseFailed: 'Failed to close',
    errOpenFailed: 'Could not open trade',
    errTpSlFailed: 'Could not update TP/SL',
  },
  backtest: {
    title: 'Backtest',
    interval1m: '1m',
    interval5m: '5m',
    interval15m: '15m',
    interval30m: '30m',
    tabRun: 'Single Test',
    tabSweep: 'Parameter Sweep',
    tabWalkforward: 'Walk-Forward',
    tabHistory: 'History',
    pair: 'Pair',
    pairPlaceholder: 'e.g. BTCUSDT',
    period: 'Period',
    strategy: 'Strategy',
    startDate: 'Start Date/Time',
    endDate: 'End Date/Time',
    initialCapital: 'Initial Capital',
    marginPerTrade: 'Margin / Trade',
    leverage: 'Leverage',
    feeRate: 'Fee Rate',
    feeRateUnit: 'rate',
    rankMetric: 'Ranking Metric',
    rankMetricTrain: 'Ranking Metric (used for train selection)',
    rankTotalPnl: 'Total PnL',
    rankWinRate: 'Win Rate',
    rankProfitFactor: 'Profit Factor',
    rankExpectancy: 'Expectancy/Trade',
    rankMaxDrawdown: 'Max Drawdown (lower=better)',
    fieldHmaPeriod: 'HMA Period',
    fieldAdxPeriod: 'ADX Period',
    fieldAdxThreshold: 'ADX Threshold',
    fieldBoxMult: 'Box Multiplier (×ATR)',
    fieldRsiDeadzone: 'RSI Dead Zone (±points)',
    fieldPullbackMult: 'Pullback Distance (×ATR)',
    fieldRsiTrigger: 'RSI Momentum Threshold',
    fieldAtrPeriod: 'ATR Period',
    fieldSlMult: 'SL Multiplier (×ATR)',
    fieldSlPct: 'SL %',
    fieldTpPct: 'TP %',
    fieldChopPeriod: 'CHOP Period',
    fieldChopThreshold: 'CHOP Threshold',
    fieldMinRR: 'Min. Reward:Risk',
    fieldMaxDailyLoss: 'Daily Loss Limit %',
    gridHint: 'Fields left blank are not swept. Enter multiple comma-separated values (e.g. 9,14,21).',
    gridPlaceholder: 'e.g. {ex}',
    runButton: '▶ Run Backtest',
    running: 'Running…',
    sweepButton: '▶ Run Sweep',
    sweeping: 'Sweeping…',
    walkforwardButton: '▶ Run Walk-Forward',
    trainWindow: 'Train Window (days)',
    testWindow: 'Test Window (days)',
    errNoParam: 'Enter a value for at least one parameter',
    errNoStrategy: 'Please select a strategy first',
    emptyTrades: 'No trades.',
    csvDownload: '⬇ Download CSV',
    visualizeTitle: 'Visualize trade (with real OKX data)',
    colEntry: 'Entry',
    colSide: 'Side',
    colEntryPrice: 'Entry Price',
    colExit: 'Exit',
    colExitPrice: 'Exit Price',
    colPnl: 'P&L',
    colBalance: 'Balance',
    colReason: 'Reason',
    colConfig: 'Config',
    colTrades: 'Trades',
    colWinRate: 'Win Rate',
    colMaxDD: 'Max DD',
    colDetail: 'Detail',
    colClose: 'Close',
    default: '(default)',
    metricTrades: 'Trade Count',
    metricWinRate: 'Win Rate',
    metricTotalPnl: 'Total PnL',
    metricFinalEquity: 'Final Balance',
    metricReturn: 'Return',
    metricProfitFactor: 'Profit Factor',
    metricMaxDrawdown: 'Max Drawdown',
    metricExpectancy: 'Expectancy/Trade',
    metricTotalFees: 'Total Fees',
    bankruptWarning: '⚠ Account depleted — as of {date} the balance could not cover the margin needed for a new trade, no new trade opened after this point (an open position, if any, continued to its natural end).',
    help: '❓ Help',
    verifyDataButton: '✓ Verify with OKX Data (deterministic)',
    verifying: 'Verifying…',
    verifySummary: '{ok}/{total} trades fit the candle range',
    verifyMismatch: ' — {n} mismatched',
    historyTitle: 'Backtest History',
    verifyLogs: '📋 Verification Logs',
    deleteSelected: '🗑 Delete Selected ({n})',
    deleteAll: '🗑 Delete All',
    deleteFiltered: '🗑 Delete Filtered ({n})',
    refresh: '↻ Refresh',
    emptyHistory: 'No backtests recorded yet.',
    emptyHistoryFiltered: 'No records match the filter.',
    filterAllSymbols: 'All Pairs',
    filterAllStrategies: 'All Strategies',
    filterClear: '✕ Clear Filter',
    filterDateFrom: 'From:',
    filterDateTo: 'To:',
    filterPnlPlaceholder: 'Value',
    colDate: 'Date',
    colSymbol: 'Symbol',
    colStrategyShort: 'Strategy',
    colRange: 'Range',
    loading: 'Loading…',
    notSingleTestNote: 'This record is a parameter sweep/walk-forward result — re-run it from the corresponding tab for details.',
    deleteConfirm: '{label} will be deleted. Are you sure?',
    deleteConfirmAll: 'the entire backtest history',
    deleteConfirmSelected: '{n} records',
    walkWindow: 'Windows',
    walkAvgInSample: 'Avg. In-Sample',
    walkAvgOutOfSample: 'Avg. Out-of-Sample',
    walkOverfitRatio: 'Overfit Ratio',
    walkOosPositive: 'OOS Positive Windows',
    walkOverfitHint: 'An overfit ratio close to 1 means train/test performance is consistent. Very low or negative may mean the strategy overfit to the past.',
    colTrainRange: 'Train Range',
    colTestRange: 'Test Range',
    colSelectedConfig: 'Selected Config',
    colInSamplePnl: 'In-Sample PnL',
    colOutOfSamplePnl: 'Out-of-Sample PnL',
    colOosWinRate: 'OOS Win Rate',
    verifLogsTitle: 'Verification Logs (OKX data-based, deterministic)',
    verifLogsEmpty: 'No verification records yet — use the "Verify with OKX Data" button in a backtest\'s "Detail" view.',
    verifLogsAllOk: '✓ All trades fit the candle range',
    verifLogsFail: '⚠ {n} inconsistent trades',
    verifLogsRecords: '{n} records',
    colBacktest: 'Backtest',
    colEntryTime: 'Entry Time',
    colCandleRange: 'Candle Range',
    colFits: 'Fits',
    colExitTime: 'Exit Time',
    invalidServerResponse: 'Received an invalid response from the server (HTTP {status}) — the request may have timed out (a very wide date range + fine period may have been selected) or the server may be temporarily unreachable. Try a shorter range or a coarser period (5m/15m) and try again.',
    serverError: 'Server error (HTTP {status})',
  },
  settings: {
    title: 'Settings',
    tabGeneral: 'General',
    tabApi: 'API',
    tabUsers: 'Users',
    tabSignal: 'Signal',
    tabRisk: 'Risk',
    tabWallet: 'Wallet',
    tabSms: 'SMS',
    tabSecurity: 'Security',
    tabBackups: 'Backups',
    utcOffset: 'Time Zone (UTC)',
    utcOffsetHint: 'Chart candle times, backtest date range, and trade narration are displayed in this time zone.',
    loadFailed: 'Could not load settings',
    saveFailed: 'Save error',
    exchangeSwitchBlocked: 'Cannot switch exchange (Base URL) while you have an active bot or open trade. Stop your bots / close your trades first.',
    okxWithdrawPermission: 'This API key has the "Withdraw" permission enabled — it is not accepted for your security. Create a new key on OKX with only "Read" and "Trade" permissions and enter that instead.',
    saved: 'Settings saved',
    save: 'Save',
    saving: 'Saving…',
    apiKey: 'API Key',
    secretKey: 'Secret Key',
    passphrase: 'Passphrase',
    baseUrl: 'Base URL',
    apiNote: 'Existing connections update immediately when API keys are changed.',
    secretPlaceholder: '(enter to change)',
    riskNote: 'SL is set at open and never changes.',
    riskHelp: '? Help',
    fieldSlPct: { label: 'SL Percentage', hint: '0 = use ATR  |  >0 = fixed price move from entry (e.g. 0.75). SL never changes after entry.' },
    fieldSlPctPctOnly: { hint: '0 or blank = SL OFF (this strategy has no ATR safety net — use with care). >0 = fixed percentage loss limit from entry, never changes after entry.' },
    fieldTpPct: { label: 'TP Percentage', hint: '0 or blank = TP off (position closes only via SL or a structural exit). >0 = fixed percentage profit target from entry.' },
    fieldAtrPeriod: { label: 'ATR Period', hint: 'ATR calculation length (recommended: 14)' },
    fieldAtrSlMult: { label: 'SL Multiplier (ATR)', hint: 'SL = Entry ± N × ATR — disabled if SL% > 0. SL stays fixed after entry, never adjusted.' },
    fieldSlCooldown: { label: 'SL Cooldown', hint: 'No new trade opens for this long after a stop loss triggers' },
    fieldChopPeriod: { label: 'CHOP Period', hint: 'Regime filter (Choppiness Index) calculation length. Applies to all strategies.' },
    fieldChopThreshold: { label: 'CHOP Threshold', hint: 'Default 61.8 (ON) — no trade opens while the market is sideways (choppy) above this value. 0 = disabled. Classic values: 38.2 / 50 / 61.8' },
    fieldHmaPeriod: { label: 'HMA Period', hint: 'Hull MA calculation length. Smaller = faster direction changes, larger = slower/fewer signals.' },
    fieldAdxPeriod: { label: 'ADX Period', hint: 'ADX calculation length.' },
    fieldAdxThreshold: { label: 'ADX Threshold', hint: '0 = disabled. HMA/Trend-Pullback: if >0, both the HMA direction AND ADX ≥ threshold are required — the same threshold also applies to the close/trend-invalidation decision.' },
    fieldRangeBoxMult: { label: 'Box Multiplier', hint: 'Range Bar + HMA + ADX only. Range bar box size = ATR × this multiplier.' },
    fieldRsiDeadzone: { label: 'RSI Dead Zone', hint: '0 = disabled. In SMA-50 it sets BOTH the entry band AND the exit threshold — they\'re the exact mirror of each other, but entry is NOT unconditional: SMA must first visit this band, then it opens the moment it exits the band; it closes on returning inside. In RSI+SMA it\'s a REVERSAL buffer around SMA instead (entry is unconditional, only the flip is delayed by this much).' },
    fieldPullbackMult: { label: 'Pullback Distance', hint: 'Trend-Pullback+R only. The allowed distance of price from MA50 for entry — if beyond this (price "overextended"), no trade opens. Default: 1.0' },
    fieldRsiTrigger: { label: 'RSI Momentum Threshold', hint: 'Trend-Pullback+R only. Requires RSI ≥ this value for LONG, RSI ≤ (100−this value) for SHORT as momentum confirmation. Default: 45' },
    fieldMinRR: { label: 'Min. Reward:Risk Ratio', hint: '0 = disabled. If >0, trades with a TP:SL ratio below this are not opened (e.g. 1.5).' },
    fieldMaxDailyLoss: { label: 'Daily Loss Limit', hint: '0 = disabled. If >0, no new trade opens for the day once daily loss reaches this percentage of margin. Does not affect open positions.' },
    strategySelectTitle: 'Analysis Strategy',
    strategySelectHint: 'Determines bot signals and dynamic TP/close decisions.',
    showHmaIndicator: 'HMA Indicator',
    showAdxIndicator: 'ADX Indicator',
    indicatorHint: 'Draw on the chart? Off by default — MA50/MA200/RSI/SMA are always drawn, HMA and ADX are only added to the chart if checked here.',
  },
  monitorPanel: {
    botRunningTitle: 'Bot is running — use the "Stop" button to stop it',
    watchingTitle: 'Watching an open trade',
    closeTraceTitle: 'Stop Watching',
    stopBot: '■ Stop {symbol}',
    stopWatching: '■ Stop Watching',
    manualTrade: 'Manual Trade',
    long: '▲ Long',
    short: '▼ Short',
    longTest: '▲ Long (Test)',
    shortTest: '▼ Short (Test)',
    spotStart: '▶ Buy',
    spotStartTest: '▶ Buy (Test)',
    spotSell: '⏹ Sell',
    close: '⏹ Close',
    demoModeBlocked: 'Manual trades cannot be opened in demo mode',
    alreadyOpenManual: 'A manual trade is already open',
    alreadyOpenBot: 'A bot trade is already open',
    simulationHint: 'Simulation, no real trade opened',
    closeManualTitle: 'Close the open manual trade instantly (at market price)',
    slLabel: 'SL',
    tpLabel: 'TP',
    priceMode: 'Price',
    amountMode: 'Amount',
    defaultUsedHint: 'The account default is used if left blank',
    period: 'Period',
    periodLockHint: 'The bot starts with this period and stays on it for its whole lifetime',
    starting: 'Starting…',
    startBot: '▶ Start {symbol} ({interval})',
    startBotTest: '▶ Start {symbol} (Test, {interval})',
    openedMsg: '{side} opened',
    closedMsg: 'Trade closed',
  },
  botControl: {
    greeting: 'Hello,',
    greetingName: '{name}',
    activeExchange: 'Active Exchange',
    activeExchangeNone: '-',
    activeExchangeInvalid: 'Invalid API Credentials',
    activeExchangeHelpTooltip: 'Enter your API credentials in Settings',
    activeExchangeWithdrawWarning: 'Your API key has the "Withdraw" permission enabled. If the key leaks, your balance can be withdrawn — create a new key on OKX with only "Read" and "Trade" permissions and replace it in Settings.',
    title: 'Bot Settings',
    viewerBadge: 'Read-Only Mode',
    noActiveBots: 'No active bots.',
    activeBots: 'Active Bots',
    running: 'Running',
    market: 'Market',
    spot: 'Spot',
    futures: 'Futures',
    futuresDisabledOkxTr: 'OKX TR does not offer futures trading — only Spot is available.',
    pair: 'Pair',
    pairPlaceholder: 'e.g. AXSUSDT',
    quantity: 'Amount',
    margin: 'Margin',
    leverageLabel: 'Leverage — selected: {leverage}x',
    demoModeTitle: 'Demo Mode',
    demoModeText: 'You can use Trace (4 pairs) and the Test Bot. A subscription is required for real trades.',
    runningInfo: '{symbol} running',
    maxPairsTitle: 'Up to {max} pairs can be traced',
    updateTraceTitle: 'Update margin/leverage settings',
    startTraceTitle: 'Start tracing — open a bot or manual trade from the tab',
    traceButton: '👁 Trace',
    subscribeButton: 'Subscribe',
    stopSuccess: '{symbol} bot stopped',
    stopButton: 'Stop',
    openManualTrades: 'Open Manual Trades',
    entryLabel: 'Entry',
    slNone: '—',
    tpNone: 'none',
    closeButton: 'Close',
    closeButtonSpot: 'Sell',
    ruleRsimaEntry: 'Entry unconditional/instant: RSI vs SMA direction — no TP, only SL',
    ruleRsimaFlip: 'Closes+flips at the same time once the SMA±DeadZone buffer is crossed',
    ruleRsima50Entry: 'Entry: SMA must first visit the Dead Zone (50±{dz}) — opens LONG/SHORT at the candle close where it exits the band',
    ruleRsima50Exit: 'Stays open until SMA returns to the Dead Zone, closes when it does — no TP, only SL',
    ruleTrendPullback: 'MA50/MA200 trend + Pullback:{pb}×ATR + RSI≥{rt}',
    ruleThresholdLabel: 'Threshold:{v}',
    ruleThresholdOffLabel: 'Threshold:off',
    ruleAdxThresholdLabel: 'ADX Threshold:{v}',
    ruleAdxThresholdOffLabel: 'ADX Threshold:off',
    ruleNoFixedTp: 'No fixed TP, only SL (backstop) — closes when the trend breaks',
    riskDeadzone: 'Dead Zone:{v}',
    riskCooldown: 'Cooldown:{v}min',
  },
  login: {
    googleFailed: 'Google sign-in failed. Please try again.',
    tfaSetupRequired: 'Two-step verification is required for your account. Set it up now to continue.',
    tfaCancel: 'Cancel',
    accountBlocked: 'Your account has been blocked. Please contact the administrator.',
    loginFailed: 'Login failed',
    registerFailed: 'Registration failed',
    serverUnreachable: 'Could not connect to the server',
    greeting: 'Hello,',
    login: 'Log in',
    register: 'Create Account',
    or: 'or',
    loginTab: 'Log In',
    registerTab: 'Create Account',
    loginIdPlaceholder: 'Email Address or Username',
    passwordPlaceholder: 'Password',
    forgotPassword: 'Forgot Password',
    loggingIn: 'LOGGING IN…',
    loginButton: 'LOG IN',
    fullNamePlaceholder: 'Full Name',
    emailPlaceholder: 'Email Address',
    passwordHint: 'Password must be at least 10 characters and contain at least one letter and one digit.',
    consent1: 'I consent to my identity, contact and marketing data being processed in order to send advertising, promotions and commercial electronic messages via my preferred communication channels.',
    consentEmail: 'Email',
    consentSms: 'SMS/Call',
    consent2: 'I give explicit consent to my identity, contact, customer transaction and marketing data being processed — including profiling and analysis activities — in order to offer products and services customized to my usage habits and needs.',
    platformNoticeTitle: '🛡 TrendSniper Guarantees',
    platformNoticeItem1: 'This site never gives investment advice.',
    platformNoticeItem2: 'It never uses or manages your investments outside the strategies you choose yourself.',
    platformNoticeItem3: 'It never trades without authorization using your OKX TR / OKX Global exchange accounts.',
    platformNoticeItem4: 'It never charges you any fee beyond the subscription fee.',
    kvkkModalTitle: 'Personal Data Processing Notice',
    agreeKvkkPost: ' and accept it.',
    termsModalTitle: 'Terms of Use',
    agreeTermsMid: ' and the',
    privacyModalTitle: 'Privacy Policy',
    agreeTermsPost: ', and accept them.',
    mustAcceptLegal: 'You must accept the Processing Notice and the Terms of Use/Privacy Policy to continue.',
    registering: 'CREATING ACCOUNT…',
    registerButton: 'CREATE ACCOUNT',
    continueWithGoogle: 'Continue with Google',
  },
  tradeHistory: {
    title: 'Trade History',
    buyLabel: 'BUY',
    report: '📊 Report',
    deleteSelected: '🗑 Delete Selected ({n})',
    deleteAll: '🗑 Delete All',
    refresh: '↻ Refresh',
    searchPlaceholder: 'Search pair…',
    allSides: 'All Sides',
    allStatuses: 'All Statuses',
    clearFilters: '✕ Clear',
    noTrades: 'No trades yet.',
    noFilterMatch: 'No trades match the filter.',
    colSymbol: 'Pair',
    colSide: 'Side',
    colEntry: 'Entry',
    colExit: 'Exit',
    colSl: 'SL',
    colTp: 'TP',
    colPnl: 'P&L',
    colFee: 'Fee',
    colMargin: 'Margin',
    colLeverage: 'Leverage',
    colAnalysisPeriod: 'AP',
    colAnalysisPeriodTitle: 'Analysis Period',
    colSignal: 'Signal',
    colStatus: 'Status',
    colOpenCloseTime: 'Open/Close Time',
    colOpenCloseTimeTitle: 'Open / Close Time',
    watching: 'Watching',
    clickToWatch: 'Click to watch live',
    visualizeTitle: 'Visualize trade (with real OKX data)',
    rowsPerPage: '{n} rows',
    total: '(total {n})',
    deleteConfirm: '{label} will be deleted. Are you sure?',
    deleteConfirmAll: 'the entire trade history',
    deleteConfirmSelected: '{n} trades',
  },
  reportModal: {
    title: 'Reports',
    tradeCount: '{n} trades',
    tabHistory: 'Trade History',
    tabAnalytics: 'Analysis Report',
    allPairs: 'All Pairs',
    allSides: 'All Sides',
    allStatuses: 'All Statuses',
    closed: 'Closed',
    open: 'Open',
    signalPlaceholder: 'Signal type…',
    real: 'Real',
    test: 'Test',
    all: 'All',
    reset: 'Reset',
    loading: 'Loading…',
    noFilterMatch: 'No trades match the filter.',
    noData: 'No data',
    statTrades: 'Trades',
    statWinRate: 'Win Rate',
    statTotalPnl: 'Total P&L',
    statTotalFee: 'Total Fee',
    statProfitFactor: 'Profit Factor',
    statAvgDuration: 'Avg. Duration',
    colSymbol: 'Pair',
    colSide: 'Side',
    colEntry: 'Entry',
    colExit: 'Exit',
    colSl: 'SL',
    colTp: 'TP',
    colFee: 'Fee',
    colMargin: 'Margin',
    colLeverage: 'Leverage',
    colSignal: 'Signal',
    colStatus: 'Status',
    colDate: 'Date',
    colDuration: 'Duration',
    metricTotalTrades: 'Total Trades',
    metricWins: 'Wins',
    metricLosses: 'Losses',
    metricWinRate: 'Win Rate',
    metricNetPnl: 'Net P&L ($)',
    metricProfitFactor: 'Profit Factor',
    metricAvgWin: 'Avg. Win ($)',
    metricAvgLoss: 'Avg. Loss ($)',
    metricAvgDuration: 'Avg. Duration',
    metricTotalFee: 'Total Fee ($)',
    cumPnlTitle: 'Cumulative P&L ($)',
    sideBreakdownTitle: 'P&L by Side',
    best: 'Best:',
    worst: 'Worst:',
    symbolBreakdownTitle: 'P&L by Pair',
    minutesShort: '{n} min',
    hoursMinutesShort: '{h}h{m}m',
  },
  chart: {
    rsi50Note: ' (level 50)',
    rsimaRefNote: ' (reference)',
    entry: 'Entry',
    periodTitle: 'Candle period',
    drawTrend: 'Trend Line',
    drawRange: 'Price Range',
    drawHLine: 'Horizontal Line',
    drawVLine: 'Vertical Line',
    drawClearAll: 'Clear drawings',
    longShortRatio: 'Long/Short Ratio (Market-wide, OKX)',
    resetButton: '↺ Reset',
    resetTitle: 'Reset Chart View',
    hmaDirection: 'HMA Direction:',
    up: 'UP',
    down: 'DOWN',
    akPct: 'O/C(%)',
    akVal: 'O/C(Value)',
    mmPct: 'High/Low(%)',
    mmVal: 'High/Low(Value)',
    dragTpTitle: 'Drag to change TP (manual trades only)',
    dragSlTitle: 'Drag to change SL (manual trades only)',
    tpSlUpdateFailed: 'Could not update TP/SL',
  },
  tradeChartModal: {
    interval1D: '1D',
    strategyManual: 'Manual',
    fetchFailed: 'Could not load chart data',
    loading: 'Loading…',
    noCandles: 'No candle data found for this time range.',
    visualizationTitle: 'Trade Visualization',
    strategyLabel: 'Strategy:',
    periodLabel: 'Period:',
    entryLabel: 'Entry:',
    exitLabel: 'Exit:',
    entryLineLabel: 'Entry',
    exitLineLabel: 'Exit',
    decisionRsiEntry: 'Decision-moment RSI (at the actual trade price):',
    decisionRsiExit: 'Decision-moment exit RSI (at the actual trade price):',
    checkpointNote: 'ℹ️ The RSI/SMA line below is based on candle close (chart reference). This strategy doesn\'t wait for candle close — entry/exit usually happens INSIDE the candle (at its low/high); the real decision value at that moment is shown separately above as "Decision-moment RSI".',
    rsimaRefNote: ' (reference)',
    resetTitle: 'Show full range',
    play: 'Play',
    pause: 'Pause',
    restart: 'Restart (stop)',
    entryMoment: 'Entry moment',
    exitMoment: 'Exit moment',
    playbackSpeed: 'Playback speed',
    entryBadge: '🟢 ENTRY MOMENT —',
    exitBadge: '🔴 EXIT MOMENT —',
    narrativeTitle: 'Description',
    narrativeContext: 'Context',
    narrativeEntry: 'Entry Moment',
    narrativeProcess: 'Position Process',
    narrativeExit: 'Exit',
    sideLong: 'LONG (buy)',
    sideShort: 'SHORT (sell)',
    days: '{n}d',
    hoursShort: '{n}h',
    minutesShort2: '{n}min',
    configUsed: 'Parameters used: {list} (unspecified ones used the platform default).',
    configDefault: 'No parameters were customized — everything ran with platform default values.',
    configUnknown: 'The exact parameter set used for this trade is not separately stored in live trade records.',
    contextText: '{symbol} pair, {interval} period, "{strategy}" strategy. {config}',
    entryBase: 'A {side} position was opened at {time} at a price of {price}.',
    entryTrendUp: 'in an uptrend (MA50 > MA200)',
    entryTrendDown: 'in a downtrend (MA50 < MA200)',
    entryTrendPullback: ' At entry the market was {trend} (MA50 {ma50}, MA200 {ma200}); it triggered because price was close enough to MA50 (pullback condition) and RSI ({rsi}) supported the momentum threshold.',
    entryTrendPullbackFallback: ' It triggered because the trend (MA50/MA200) and pullback condition were met.',
    entryHmaAdx: ' This strategy is state-based: whenever flat, it opens a position instantly in the current HMA direction — it never waits for a flip.{adxNote}',
    entryHmaAdxNote: ' ADX was {adx} at entry.',
    entryRsi50Cp: ' The real basis for the decision was the "decision-moment" RSI value, which doesn\'t wait for candle close: RSI {rsi} — it triggered the instant it first exited the 50 midline band.',
    entryRsi50Fallback: ' It triggered the instant RSI first exited the 50 midline band.',
    entryRsimaCp: ' At the decision moment RSI ({rsi}) was compared with SMA ({rsiMa}) — entry happened unconditionally and instantly because {cmp}.',
    entryRsimaCpLong: 'RSI was at or above SMA',
    entryRsimaCpShort: 'RSI was below SMA',
    entryRsimaFallback: ' It triggered unconditionally and instantly via the RSI/SMA comparison.',
    entryRsima50: ' At the close of the decision candle, SMA (the 14-period average of RSI) was {rsiMa} — entry happened because {cmp}.',
    entryRsima50Long: 'SMA was above the Dead Zone band',
    entryRsima50Short: 'SMA was below the Dead Zone band',
    entryRsima50Fallback: ' It triggered because SMA visited the Dead Zone and then exited the band at candle close.',
    processStillOpen: 'The position is still open right now — it has not closed yet.',
    processSlHit: 'The position stayed open for {duration} until it hit the fixed Stop Loss set at open — the SL never changed after entry.',
    processTrendReversal: 'After the position stayed open for {duration}, the MA50/MA200 trend relationship reversed; the system treated this as a safety signal and closed it instantly without waiting for trailing/SL.',
    processGeneric: 'The position stayed open for {duration}.',
    processHmaReversal: 'The position stayed open for {duration}; since there is no TP (only a fixed SL safety net), it was carried as long as HMA stayed in the same direction, and was closed immediately once HMA reversed.',
    processHmaSl: 'The position stayed open for {duration}, remaining fixed until the Stop Loss safety net triggered.',
    processRsi50Generic: 'The position stayed open for {duration} until RSI returned to the 50 midline (or SL/TP triggered).',
    processRsimaGeneric: 'The position stayed open for {duration} until RSI fully crossed the SMA±Dead Zone buffer of its current side (or SL triggered).',
    processRsima50Generic: 'The position stayed open for {duration} until SMA fell back into the Dead Zone, or the fixed SL was hit.',
    exitBase: 'It closed at {time} at a price of {price}.',
    exitReasonSuffix: ' Closing reason: {reason}.',
    exitResultSuffix: ' Result: {result} ({pnl}).',
    resultProfit: 'PROFIT',
    resultLoss: 'LOSS',
    exitReasonSlHit: 'Closed because the Stop Loss (SL) level was reached',
    exitReasonTrailingSl: 'Closed PROFITABLY because the trailing stop (SL moved in profit direction) triggered',
    exitReasonTpHit: 'Closed because the Take Profit (TP) target was reached',
    exitReasonTrendReversalPullback: 'Closed immediately for safety because MA50 crossed to the other side of MA200 (trend reversed)',
    exitReasonTrendReversalHma: 'Closed because the HMA direction reversed (a new {side} position was opened at the same time)',
    exitReasonRsi50Deadzone: 'Closed because RSI returned to the 50 midline (dead zone)',
    exitReasonRsi50Extreme: 'Closed because RSI pulled back from the overbought/oversold zone (TP trailing)',
    exitReasonRsimaExit: 'Closed because RSI crossed to the other side of the SMA reference line',
    exitReasonRsima50Deadzone: 'Closed because SMA fell back into the Dead Zone band',
    exitReasonBacktestEnd: "Closed and marked at the last price because the backtest's data range ended — not a real strategy signal",
    exitReasonSlExternal: 'Detected as closed on the OKX side; since the result was a loss, the Stop Loss (SL) likely triggered (the exact mechanism cannot be confirmed from OKX history)',
    exitReasonTpExternal: 'Detected as closed on the OKX side; since the result was profitable/neutral, the Take Profit (TP) target was likely reached (the exact mechanism cannot be confirmed from OKX history)',
    exitReasonBotStopped: 'The open position was automatically closed because the user stopped the bot',
    exitReasonManual: 'Closed manually by the user',
  },
  logViewer: {
    title: 'Backend Logs',
    lineCount: '{visible} / {total} lines',
    filterAll: 'All',
    filterAnalysis: 'Analysis',
    filterTrade: 'Trade',
    filterBot: 'Bot',
    filterReconcile: 'Reconcile',
    filterError: 'Error',
    searchPlaceholder: 'Search…',
    resume: 'Resume',
    pause: 'Pause',
    clear: 'Clear',
    clearButton: '✕ Clear',
    empty: 'No logs yet…',
    scrollToBottom: '↓ Go to bottom',
  },
  walletTransfer: {
    infoNote: 'OKX does not have separate "spot" and "futures" wallets — the Funding account is for deposits/withdrawals, while the Trading account is the shared balance the bot uses when opening positions (spot or futures alike). You can move USDT between them.',
    balancesFailed: 'Could not load balances',
    detailFailed: 'Could not load details',
    invalidAmount: 'Enter a valid amount',
    flipDirection: 'Flip direction',
    refreshBalances: 'Refresh balances',
    hideDetail: '▾ Hide balance detail',
    showDetail: '▸ Why is my balance this much? (detail)',
    loading: 'Loading…',
    totalEquity: 'Total equity (Trading)',
    availableForOrders: 'Available for new orders',
    lockedInPositions: 'Locked in open positions/algo orders',
    lockedInPendingOrders: 'Locked in pending limit orders',
    openPositionsTitle: 'Open positions locking margin',
    noOpenPositions: 'No open futures positions — if there\'s a difference between the available amount and total equity, it\'s from pending orders.',
    allAssetsTitle: 'My Assets',
    convertInfoNote: 'USDTTRY is not a "position" — it\'s the tool for converting between TRY and USDT, unlike other pairs (e.g. BTCUSDT, BTCTRY) which are for profit-seeking trades. Below you can convert your USDT/TRY balance within the Trading account.',
    convertFailed: 'Conversion failed',
    convertSuccess: '✓ Conversion completed.',
    converting: 'Converting…',
    convertButton: 'Convert ({direction})',
    directionTryToUsdt: 'TRY → USDT',
    directionUsdtToTry: 'USDT → TRY',
  },
  liveStatus: {
    title: 'Live Status',
    currentPrice: 'Current Price',
    candleClose: 'candle close',
    floatingPnl: 'Floating PnL:',
    marketRegime: 'Market Regime (CHOP)',
    threshold: 'Threshold:',
    chopSuppressed: ' — Sideways, signal suppressed',
    chopTrend: ' — Trending, filter not active',
    eventLog: 'Activity Log',
    noEvents: 'No events yet',
    openPositions: 'Open Positions',
    spotSuffix: '(Spot)',
    hmaDirection: 'HMA Direction',
    rangeBarSuffix: ' (range bar)',
    up: '▲ UP',
    down: '▼ DOWN',
    box: 'Box:',
    barSuffix: 'bars',
    adxThresholdSuffix: ' (threshold: {v})',
    adxInfoSuffix: ' (info)',
    filterPassed: 'Filter passed',
    filterBlocking: '< {v} — filter blocking',
    filterOff: 'Filter disabled',
    rsimaLabel: 'RSI (unconditional/instant, no TP, flip buffer)',
    longRsiRsima: '▲ LONG (RSI≥SMA)',
    shortRsiRsimaSpot: '— RSI<SMA (no shorting on spot)',
    shortRsiRsima: '▼ SHORT (RSI<SMA)',
    blockedShortSpotRsima: 'Flat — shorting not possible on spot, opens instantly once RSI≥SMA (LONG)',
    instantOpenRsima: 'Flat — opens instantly based on RSI vs SMA (no waiting)',
    buffer: 'Buffer: {v} (SMA±{dz}) — closes+flips once crossed (SL always active)',
    rsima50Label: 'SMA (14-period RSI average, candle close only)',
    longRsima50: '▲ LONG (SMA≥50)',
    shortRsima50Spot: '— SMA<50 (no shorting on spot)',
    shortRsima50: '▼ SHORT (SMA<50)',
    blockedShortSpotRsima50: 'Flat — shorting not possible on spot, opens once SMA visits the Dead Zone then exits upward (LONG)',
    instantOpenRsima50: 'Flat — SMA must first visit the Dead Zone, opens at the candle close where it exits the band',
    rsima50ExitNote: 'Exit: closes at the candle close where SMA returns to the Dead Zone (SL is the backstop)',
    rsiMaRef: 'SMA (reference)',
    trendLabel: 'Trend (MA50/MA200)',
    uptrend: '▲ Uptrend (MA50>MA200)',
    downtrend: '▼ Downtrend (MA50<MA200)',
    waitingNewPullback: '⏳ Waiting for a new pullback — price must first move outside the band, then approach again (repeated entries in the same zone are blocked)',
    blockedShortSpotTrend: 'Flat — shorting not possible on spot, waiting for an uptrend',
    signalLabel: 'Signal: {v}',
    waiting: 'Waiting',
    trendPullbackExitNote: 'SL: {v} (backstop) — closes when the trend reverses, no fixed TP',
    adxRsiMomentum: 'RSI Momentum Threshold: {v}',
  },
  userManager: {
    subActive: 'Active',
    subTrial: 'Trial',
    subInactive: 'Inactive',
    subCancelled: 'Cancelled',
    blocked: 'Blocked',
    back: '← Back',
    fullName: 'Full Name',
    subscriptionStatus: 'Subscription Status',
    subStart: 'Subscription Start',
    subEnd: 'Subscription End',
    expired: 'Expired',
    daysLeft: '{n} days left',
    accountStatus: 'Account Status',
    active: '✓ Active',
    blockedBtn: '⊘ Blocked',
    notes: 'Notes',
    notesPlaceholder: 'Admin note (optional)…',
    newPassword: 'New Password',
    changePlaceholder: '(enter to change)',
    okxApiKeysHeader: 'OKX CONNECTION STATUS',
    okxInfoOnly: 'Informational only — admins cannot see or change API credentials, only test whether the connection currently works.',
    baseUrl: 'Base URL',
    testConnection: 'Test',
    testing: 'Testing…',
    testValid: '✓ Connection working',
    testInvalid: '✕ Credentials entered but invalid/rejected',
    testMissing: '✕ No credentials entered',
    saved: 'Saved',
    saveError: 'Save error',
    saving: 'Saving…',
    save: 'Save',
    confirmDeleteBulk: 'Delete {n} users?',
    confirmDeleteSingle: 'Delete "{email}"?',
    confirmDeleteSub: 'This action cannot be undone. Existing sessions will be closed.',
    cancel: 'Cancel',
    delete: 'Delete',
    systemAccessTitle: 'System Access (Admin / Viewer)',
    adminUsername: 'Admin Username',
    adminPassword: 'Admin Password',
    viewerUsername: 'Viewer Username',
    viewerPassword: 'Viewer Password',
    registeredUsers: 'Registered Users',
    refresh: 'Refresh',
    searchPlaceholder: 'Search by name or email…',
    all: 'All',
    selectedCount: '{n} selected',
    activateBulk: '✓ Activate',
    blockBulk: '⊘ Block',
    changeSubscription: 'Change subscription…',
    apply: 'Apply',
    deleteBulk: '✕ Delete',
    clearSelection: 'Clear selection',
    colUser: 'User',
    colSubscription: 'Subscription',
    colEnd: 'End',
    loading: 'Loading…',
    noUsers: 'No registered users yet',
    noFilterMatch: 'No users match the filter',
    daysLeftShort: '{n}d',
    expiredShort: 'Expired',
    editTitle: 'Edit',
    deleteTitle: 'Delete',
  },

  support: {
    title: 'Support Requests',
    myTickets: 'My Requests',
    allTickets: 'All Requests',
    createButton: '+ Create New Request',
    subjectLabel: 'Subject',
    subjectPlaceholder: 'Briefly summarize your issue',
    categoryLabel: 'Category',
    messageLabel: 'Message',
    messagePlaceholder: 'Describe your issue in detail…',
    submitButton: 'Create Request',
    cancelButton: 'Cancel',
    catTechnical: 'Technical Issue',
    catAccount: 'Account / Membership',
    catBilling: 'Payment / Subscription',
    catBot: 'Bot / Strategy',
    catOther: 'Other',
    statusOpen: 'Open',
    statusInProgress: 'In Progress',
    statusResolved: 'Resolved',
    statusClosed: 'Closed',
    statusFilterAll: 'All Statuses',
    noTickets: 'You have no requests yet.',
    noTicketsAdmin: 'There are no support requests.',
    messageCount: '{n} messages',
    lastMessage: 'Last message {time}',
    backToList: '← Back to List',
    replyPlaceholder: 'Write your reply… (Enter to send, Shift+Enter for a new line)',
    sendButton: 'Send',
    closeTicketButton: 'Close Request',
    confirmClose: 'Are you sure you want to close this request? No new messages can be added once closed.',
    closedNotice: 'This request has been closed.',
    supportTeamLabel: 'Support Team',
    you: 'You',
    loadFailed: 'Failed to load requests',
    createFailed: 'Failed to create request',
    sendFailed: 'Failed to send message',
    userColumn: 'User',
  },

  home: {
    navFeatures: 'Features',
    navStrategies: 'Strategies',
    navWorkflow: 'How It Works',
    ctaLogin: 'Sign In',

    eyebrow: 'OKX Futures · Automated Long/Short Bot',
    heroTitleBefore: 'From the moment a signal fires ',
    heroTitleHighlight: 'to the moment the position closes',
    heroTitleAfter: ', your bot is on watch',
    heroLead: 'TrendSniper opens automated Long/Short positions on your OKX Futures account using MA50/RSI-based strategies, manages your risk, and lets you monitor the whole process live.',
    ctaExplore: 'Explore Features',
    ctaBuy: 'Buy Now',

    chip1: 'Automated Long/Short',
    chip2: 'OKX Global & OKX TR',
    chip3: 'Backtest & Sweep',
    chip4: 'Test/Simulation Mode',
    chip5: 'Drag & Drop TP/SL',
    chip6: 'TR/EN · Light/Dark Theme',

    ticketLabel: 'OPEN POSITION',
    ticketSymbol: 'BTC-USDT-SWAP',
    ticketSide: 'LONG',
    ticketStrategyLabel: 'Strategy',
    ticketStrategyValue: 'Trend-Pullback + R',
    ticketLeverageLabel: 'Leverage',
    ticketLeverageValue: '10x',
    ticketEntryLabel: 'Entry Price',
    ticketStatusLabel: 'Status',
    ticketStatusValue: 'Monitoring',
    ticketPnlLabel: 'Live PNL',

    featuresTitle: 'Manage it all from one panel',
    featuresLead: 'The entire process, from signal to position close, is controlled from a single panel.',
    feature1Title: 'Automated Long/Short Bot',
    feature1Desc: 'The strategy locks as a snapshot when settings are saved; the bot runs on that snapshot and auto-closes the position when stopped.',
    feature2Title: 'OKX Global & OKX TR',
    feature2Desc: 'Both OKX account regions are supported with independent API keys; trade on Spot and Futures markets.',
    feature3Title: '4 Built-in Strategies',
    feature3Desc: 'Range Bar+HMA+ADX, RSI+SMA, Trend-Pullback+R and SMA-50 Level — each with its own tunable risk rules.',
    feature4Title: 'Backtest, Sweep & Walk-Forward',
    feature4Desc: 'Test your strategy against historical data with a single backtest, a parameter sweep, or walk-forward validation before going live.',
    feature5Title: 'Test/Simulation Mode',
    feature5Desc: 'A fully functional simulation mode for unlimited practice with no subscription required and no real money at risk.',
    feature6Title: 'Manual Trading & Drag-to-Adjust TP/SL',
    feature6Desc: 'Open manual positions independent of the bot; drag TP/SL levels directly on the chart to adjust them instantly.',
    feature7Title: 'Live Chart & Status Panel',
    feature7Desc: 'Track MA50/MA200, RSI/SMA and strategy-specific HMA/ADX overlays in real time over WebSocket.',
    feature8Title: 'Risk Management',
    feature8Desc: 'ATR- or percentage-based SL/TP, post-stop cooldown, and minimum reward:risk checks protect every position.',
    feature9Title: 'Multi-User Isolation',
    feature9Desc: 'Every user runs fully isolated with their own API keys, settings and trade history; trial/active subscription tiers are supported.',
    feature10Title: 'TR/EN & Light/Dark Theme',
    feature10Desc: 'The entire interface works in Turkish/English and light/dark themes, at the same speed on every device.',

    strategiesTitle: 'Four built-in strategies, four ways to read the market',
    strategiesLead: 'Every strategy runs on a locked snapshot; parameters can be validated with a backtest beforehand.',
    strategy1Name: 'Range Bar+HMA+ADX',
    strategy1Desc: 'Evaluates Hull MA direction changes on range-bar candles together with an ADX trend-strength filter.',
    strategy2Name: 'RSI+SMA',
    strategy2Desc: 'Tracks the crossover between RSI and its moving average (SMA); a buffer zone around SMA determines when to flip direction.',
    strategy3Name: 'Trend-Pullback+R',
    strategy3Desc: 'Looks for MA50/MA200 trend direction, a pullback toward MA50, and RSI momentum confirmation all at once.',
    strategy4Name: 'SMA-50 Level',
    strategy4Desc: 'Treats SMA dipping into the dead zone around level 50 and exiting it as a clear, simply-ruled entry signal.',

    workflowTitle: 'The bot process, start to finish',
    workflowLead: 'Every step from signal to report runs automatically; you only set the strategy and risk parameters.',
    step1Status: 'Signal Detection',
    step1Desc: 'The selected strategy continuously scans live candle data and generates a signal when entry conditions are met.',
    step2Status: 'Position Opened',
    step2Desc: 'The bot opens a Long/Short position on your OKX account based on your locked settings (leverage, margin, SL/TP).',
    step3Status: 'Risk Management',
    step3Desc: 'ATR/percentage-based SL-TP, minimum reward:risk and cooldown rules are enforced for as long as the position stays open.',
    step4Status: 'Close & Report',
    step4Desc: 'The position closes via TP/SL or a structural exit and is automatically recorded to trade history and detailed reports.',

    trustTitle: 'You stay in control',
    trustItem1: 'TrendSniper never gives investment advice; every strategy and risk decision is yours.',
    trustItem2: 'No trade is opened and no fee is charged without your permission.',
    trustItem3: 'Every trade happens on your own OKX account with your own API keys — your balance is never held by us.',
    trustItem4: 'In Test/Simulation mode, real money is never at risk.',

    ctaBannerTitle: 'Try your strategy in test mode today',
    ctaBannerLead: 'Sign up and place unlimited test/simulation trades without risking real money.',
    ctaBannerButton: 'Sign In',

    footerTagline: 'A signal-based automated trading platform for OKX Futures.',
    footerProductHeading: 'Product',
    footerCorporateHeading: 'Corporate',
    footerAbout: 'About Us',
    footerContact: 'Contact',
    footerPrivacy: 'Privacy Policy',
    footerKvkk: 'KVKK Notice',
    footerTerms: 'Terms of Use',
    footerRights: '© {year} TrendSniper. All rights reserved.',
    footerBuiltBy: 'built by',
  },
  sms: {
    note: 'Only system messages are sent via NetGSM: security alerts and two-step verification codes (OTP account). Passwords are not shown after saving.',
    netgsmTitle: 'NetGSM Details',
    username: 'Username',
    header: 'Sender Name (Header)',
    otpPassword: 'OTP Password (verification codes and security alerts)',
    individualPassword: 'Individual Password (commercial)',
    merchantPassword: 'Merchant Password (commercial)',
    passwordSet: 'Set',
    passwordNotSet: 'Not set',
    keepPlaceholder: 'Type a new password to change it',
    clear: 'Delete',
    clearConfirm: 'Delete this password?',
    iysNote: 'Individual/Merchant are commercial accounts: messages to numbers without IYS consent are not delivered, yet NetGSM still reports success.',
    saved: 'SMS settings saved.',
    testTitle: 'Test SMS and Remaining Credits',
    testSend: 'Send Test SMS',
    testSent: 'Test SMS sent.',
    testViaFallback: '(sent via the standard line because there is no OTP package)',
    testFailed: 'Test SMS could not be sent.',
    balance: 'Remaining SMS Credits',
    balanceFailed: 'Balance query failed.',
    logTitle: 'SMS Delivery Report',
    allStatuses: 'All statuses',
    sent: 'Sent',
    failed: 'Failed',
    logSummary: '{sent} sent, {failed} failed',
    colDate: 'Date',
    colPurpose: 'Purpose · Account',
    colPhone: 'Phone',
    colStatus: 'Status',
    colDetail: 'Detail',
    noLogs: 'No records in this range.',
    alertTitle: 'Security Alerts',
    alertHint: 'Lockouts caused by repeated failed sign-ins, system administrator sign-ins from a previously unseen IP address and high/critical findings of the weekly dependency scan are sent to this number by SMS (OTP account). If left empty, no SMS is sent and events are only written to the server log.',
    alertPhone: 'Security alert phone',
    alertTest: 'Send Test Alert',
    alertSaved: 'Security alert phone saved.',
    alertTestSent: 'Test alert sent.',
  },
  tfa: {
    title: 'Two-Step Verification',
    enabled: 'On',
    methodTotp: 'Authenticator app',
    methodSms: 'SMS ({phone})',
    backupRemaining: 'Backup codes left: {n}',
    password: 'Your password (for confirmation)',
    newBackupCodes: 'New Backup Codes',
    disable: 'Turn Off',
    requiredNote: 'Two-step verification is required for your account and cannot be turned off.',
    enabledNow: 'Two-step verification is now on.',
    googleExempt: 'Because you sign in with Google, verification is handled by your Google account’s own two-step verification. We recommend enabling 2-Step Verification on your Google account.',
    disabledByAdmin: 'Two-step verification is currently turned off by the system administrator.',
    policyTitle: 'Two-Step Verification (2FA)',
    policyHint: 'A code from an authenticator app (or SMS) is required in addition to the password. In required mode, users who have not set it up are sent to the setup screen at their next sign-in. Users signing in with Google rely on their Google account’s verification. You can reset 2FA for a user who lost their phone from the Users tab.',
    policyLabel: 'Policy',
    modeOff: 'Off',
    modeOptional: 'Optional (each user turns it on)',
    modeAdmins: 'Required for the system administrator',
    modeAll: 'Required for everyone',
    smsLabel: 'Allow the SMS code method (requires the NetGSM OTP password)',
    smsNeedsOtp: 'For the SMS method, first enter the NetGSM OTP password in the SMS tab.',
    policySaved: '2FA policy saved.',
    reset: 'Reset 2FA',
    resetConfirm: "Reset this user's two-step verification? They will have to set it up again.",
    resetDone: 'Two-step verification was reset.',
    puzzleTitle: 'Sign-in Puzzle',
    puzzleHint: 'A slide-the-piece check at sign-in. With “When suspicious” it is only shown after repeated failed attempts from the same address; normal users never see it.',
    puzzleLabel: 'When to show',
    puzzleOff: 'Off',
    puzzleSuspicious: 'When suspicious (recommended)',
    puzzleAlways: 'On every sign-in',
  },
  backup: {
    note: 'The database is backed up on the server every night at 02:00 (Istanbul); the last 7 backups are kept. If R2 is configured, the same backup is also encrypted and sent off-site. Restores are not done from this screen — the system administrator does them on the server.',
    localTitle: 'Backups on the Server',
    now: 'Back Up Now',
    created: '{file} created.',
    colFile: 'File',
    colDate: 'Date',
    colSize: 'Size',
    download: 'Download',
    empty: 'No backups yet.',
    offsiteTitle: 'Off-site Backup (Cloudflare R2)',
  },
};
